<template>
  <div v-if="variants.v1 === variant" class="tw-pb-24">
    <div class="container">
      <lazy-library-title :text="vars.titleText" class="text-center" tag="h2"></lazy-library-title>
    </div>

    <library-container>
      <div class="pxp-areas-carousel mt-4 mt-md-5">
        <div class="pxp-areas-carousel-stage owl-carousel properties-carousel-stage">
          <nuxt-link
            v-for="(property, index) in properties"
            :key="`property-${index}`"
            class="pxp-areas-carousel-item"
            :external="true"
            :to="property.detail_page_url"
          >
            <theme3-properties-property-list-item :property="property" :is-match-information-hidden="true" />
          </nuxt-link>
        </div>
      </div>
    </library-container>

    <div class="container">
      <div class="text-center mt-4 mt-md-5">
        <nuxt-link :external="true" :to="ctaUrl" class="pxp-primary-cta text-uppercase pxp-animate">
          {{ ctaText }}
        </nuxt-link>
      </div>
    </div>
  </div>
  <div v-if="variants.v2 === variant" class="tw-py-24">
    <div class="container">
      <lazy-library-title :text="vars.titleText" class="text-left" tag="h3"></lazy-library-title>
    </div>

    <library-container>
      <div class="pxp-areas-carousel mt-4 mt-md-5" style="padding-left: 0">
        <div class="pxp-areas-carousel-stage owl-carousel properties-wide-card-carousel-stage">
          <nuxt-link
            v-for="(property, index) in properties"
            :key="`property-${index}`"
            class="pxp-areas-carousel-item n-link"
            :external="true"
            :to="property.detail_page_url"
          >
            <theme3-properties-property-list-item-wide-card :property="property" />
          </nuxt-link>
        </div>
      </div>
    </library-container>

    <div class="container">
      <div class="text-left mt-4 mt-md-5">
        <nuxt-link :external="true" :to="ctaUrl" class="pxp-primary-cta text-uppercase pxp-animate">
          {{ ctaText }}
        </nuxt-link>
      </div>
    </div>
  </div>
  <div v-if="variants.v3 === variant" style="text-align: left">
    <lazy-library-title :text="vars.titleText" tag="h3" class="tw-mb-6"></lazy-library-title>
    <nuxt-link
      v-for="(property, index) in properties"
      :key="`property-${index}`"
      class="pxp-areas-carousel-item"
      style="width: 100% !important"
      :external="true"
      :to="property.detail_page_url"
    >
      <theme3-properties-property-list-item
        :property="property"
        :is-match-information-hidden="true"
        :is-simple-version="true"
      />
      <div style="text-align: left" class="tw-mt-6">
        <div
          class="pxp-primary-cta text-uppercase pxp-animate tw-cursor-pointer after:tw-border-inherit"
          :style="`color: var(--purple); border-top-color: var(--purple)`"
        >
          {{ ctaText }}
        </div>
      </div>
    </nuxt-link>
  </div>

  <div v-if="variants.v4 === variant" class="tw-py-16 lg:tw-py-20">
    <div class="container">
      <h3 class="tw-text-start lg:tw-text-center">{{ vars.titleText }}</h3>
    </div>

    <library-container>
      <div class="pxp-areas-carousel mt-4 mt-md-5">
        <div class="pxp-areas-carousel-stage owl-carousel properties-carousel-stage">
          <nuxt-link
            v-for="(property, index) in properties"
            :key="`property-${index}`"
            class="pxp-areas-carousel-item"
            :external="true"
            :to="property.detail_page_url"
          >
            <theme3-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              version="v2"
            />
          </nuxt-link>
        </div>
      </div>
    </library-container>

    <div class="container">
      <div class="text-center mt-4 mt-md-5">
        <nuxt-link :external="true" :to="ctaUrl" class="pxp-primary-cta text-uppercase pxp-animate">
          {{ ctaText }}
        </nuxt-link>
      </div>
    </div>
  </div>

  <!-- v5: TEK KART, LOOPLU, SWIPER -->
  <div v-if="variants.v5 === variant" class="v5-single-card tw-py-16 lg:tw-py-20">
    <div class="container">
      <h4 class="tw-text-start lg:tw-text-center">{{ vars.titleText }}</h4>
    </div>

    <library-container>
      <!-- OK VE SLIDER AYNI WRAPPER İÇİNDE -->
      <div
        class="relative js-section-slider tw-mt-10"
        data-anim="slide-left delay-1"
        data-gap="30"
        data-slider-cols="xl-1 lg-1 md-1 sm-1 base-1"
      >
        <Swiper
          :key="'v5-swiper-' + properties.length"
          :modules="swiperModules"
          :slides-per-view="1"
          :space-between="0"
          :loop="true"
          :pagination="false"
          :watch-overflow="true"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          class="tw-w-full"
        >
          <SwiperSlide v-for="(property, index) in properties" :key="`properties-v5-${index}`" class="tw-w-full">
            <theme3-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              :is-simple-version="false"
              version="v2"
            />
            <div class="mt-2" style="height: 4px; background-color: #90c73d; width: 100%"></div>
          </SwiperSlide>
        </Swiper>

        <div class="d-flex tw-mt-4 tw-justify-center tw-gap-8">
          <button class="sliderNav -prev n-link js-prev nav-ctrl" @click="slidePrev" aria-label="Önceki">
            <svg width="64" height="64" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle
                cx="46"
                cy="46"
                r="45"
                transform="matrix(-1 0 0 1 92 0)"
                fill="white"
                stroke="black"
                stroke-width="2"
              />
              <path
                d="M26.9393 47.0607C26.3536 46.4749 26.3536 45.5251 26.9393 44.9393L36.4853 35.3934C37.0711 34.8076 38.0208 34.8076 38.6066 35.3934C39.1924 35.9792 39.1924 36.9289 38.6066 37.5147L30.1213 46L38.6066 54.4853C39.1924 55.0711 39.1924 56.0208 38.6066 56.6066C38.0208 57.1924 37.0711 57.1924 36.4853 56.6066L26.9393 47.0607ZM63 46L63 47.5L28 47.5L28 46L28 44.5L63 44.5L63 46Z"
                fill="black"
              />
            </svg>
          </button>

          <button class="sliderNav -next ml-20 n-link js-next nav-ctrl" @click="slideNext" aria-label="Sonraki">
            <svg width="64" height="64" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="46" cy="46" r="45" fill="white" stroke="black" stroke-width="2" />
              <path
                d="M65.0607 47.0607C65.6464 46.4749 65.6464 45.5251 65.0607 44.9393L55.5147 35.3934C54.9289 34.8076 53.9792 34.8076 53.3934 35.3934C52.8076 35.9792 52.8076 36.9289 53.3934 37.5147L61.8787 46L53.3934 54.4853C52.8076 55.0711 52.8076 56.0208 53.3934 56.6066C53.9792 57.1924 54.9289 57.1924 55.5147 56.6066L65.0607 47.0607ZM29 46L29 47.5L64 47.5L64 46L64 44.5L29 44.5L29 46Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      </div>
    </library-container>
  </div>

  <div v-if="variants.v6 === variant" class="properties-box tw-py-16 lg:tw-py-20">
    <div class="container">
      <h3 class="tw-text-start lg:tw-text-center">{{ vars.titleText }}</h3>
    </div>

    <library-container>
      <div class="pxp-areas-carousel mt-4 mt-md-5">
        <div class="pxp-areas-carousel-stage owl-carousel properties-carousel-stage">
          <nuxt-link
            v-for="(property, index) in properties"
            :key="`property-${index}`"
            class="pxp-areas-carousel-item"
            :external="true"
            :to="property.detail_page_url"
          >
            <theme3-properties-property-list-item
              :property="property"
              :is-match-information-hidden="true"
              version="v3"
            />
          </nuxt-link>
        </div>
      </div>
    </library-container>

    <div class="container">
      <div class="text-center mt-4 mt-md-5">
        <nuxt-link :external="true" :to="ctaUrl" class="pxp-primary-cta text-uppercase pxp-animate">
          {{ ctaText }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertiesMixin } from '~/units/properties/mixins/properties.mixin';
import { jQuery } from 'public/theme3/js/custom';
import { ROUTES } from '~/constants/ui.constants';
import { Pagination as SwiperPagination } from 'swiper/modules'; // v5 için yeterli

export default defineNuxtComponent({
  name: 'Theme3PropertiesBox',

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2WideCardSlider',
        v3: 'v3Sidebar',
        v4: 'v4',
        v5: 'v5Sidebar',
        v6: 'v6',
      },

      swiper: null as any | null,
      swiperModules: [SwiperPagination],
      canPaginateBack: true,
      canPaginateNext: true,
    };
  },

  computed: {
    ctaText() {
      return this.vars.ctaText || 'All Properties';
    },
    ctaUrl() {
      return this.vars.ctaUrl || ROUTES.PROPERTIES;
    },
  },

  mixins: [ComponentMixin, PropertiesMixin],

  async setup(props) {
    await fetchPropertiesManager(props.component, null);
  },

  mounted() {
    // v1 ve v4 Owl; v2 wide-card Owl; v5 Swiper (ayrı)
    if (this.variant === this.variants.v1 || this.variant === this.variants.v4 || this.variant === this.variants.v6) {
      jQuery.propertiesSlider();
    } else if (this.variant === this.variants.v2) {
      jQuery.propertiesWideCardSlider();
    }
    // v5 için jQuery init YOK
    this.onSlideChange(); // güvenli çağrı
  },

  methods: {
    onSwiper(swiper: any) {
      this.swiper = swiper || null;
    },
    onSlideChange() {
      if (!this.swiper) return;
      this.canPaginateBack = !this.swiper.isBeginning;
      this.canPaginateNext = !this.swiper.isEnd;
    },
    slidePrev() {
      if (this.swiper) this.swiper.slidePrev();
    },
    slideNext() {
      if (this.swiper) this.swiper.slideNext();
    },
  },
});
</script>

<style scoped>
::v-deep(.pxp-areas-carousel-right-arrow) {
  top: 22% !important;
}

::v-deep(.pxp-areas-carousel-left-arrow) {
  top: 22% !important;
}

::v-deep(.properties-wide-card-carousel-stage .pxp-areas-carousel-right-arrow) {
  top: 50% !important;
}

::v-deep(.properties-wide-card-carousel-stage .pxp-areas-carousel-left-arrow) {
  top: 50% !important;
}

.nav-ctrl {
  background: transparent;
  border: none;
  cursor: pointer;
  line-height: 0;
  padding: 0;
  transition: transform 0.2s ease;
}

.nav-ctrl svg {
  transition: all 0.2s ease;
}

/* Hover durumunda renkleri ters çevir */
.nav-ctrl:hover svg circle {
  fill: black; /* Arka plan siyah */
  stroke: white; /* Çerçeve beyaz */
}

.nav-ctrl:hover svg path {
  fill: white; /* Ok beyaz */
}

/* Hover efektine küçük animasyon da ekleyelim */
.nav-ctrl:hover svg {
  transform: scale(1.05);
}
</style>
